module.exports = __webpack_public_path__ + "media/kikorun.d3ef3146.mp4";